export default "__VITE_ASSET__3f556048__"